import { render, staticRenderFns } from "./UpdateModuleWindow.vue?vue&type=template&id=06965147&"
import script from "./UpdateModuleWindow.vue?vue&type=script&lang=js&"
export * from "./UpdateModuleWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports